import { render, staticRenderFns } from "./step6.vue?vue&type=template&id=0a1e2cea"
import script from "./step6.vue?vue&type=script&lang=js"
export * from "./step6.vue?vue&type=script&lang=js"
import style0 from "./step6.vue?vue&type=style&index=0&id=0a1e2cea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports